<!-- 客户管理 -->
<template>
  <div class="RegistrationList" v-loading="loading">
    <div class="cao_zuo">
      <el-button type="primary" @click="search_click">搜索</el-button>
      <!-- <el-button type="primary" style="float:right">创建</el-button> -->
    </div>
    <el-table :data="tableData" style="width: 100%">
      <el-table-column prop="name" label="姓名" width="120"></el-table-column>
      <el-table-column
        prop="company_name"
        label="公司名"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="username"
        label="帐号"
        width="120"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="phone"
        label="手机"
        width="120"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="is_experience"
        label="是否体验帐号"
        width="100"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="is_test"
        label="是否为测试账号"
        width="180"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="m_people_permissions"
        label="经纪人人数限制"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="people_permissions"
        label="职员人数限制"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="vip_start_time"
        label="vip开始时间"
        width="180"
      ></el-table-column>
      <el-table-column
        prop="vip_end_time"
        label="vip结束时间"
        width="180"
      ></el-table-column>
      <el-table-column
        prop="create_time"
        label="创建时间"
        width="180"
      ></el-table-column>
      <el-table-column
        prop="create_time"
        label="创建时间"
        width="180"
      ></el-table-column>
      <el-table-column prop label="操作" width="100">
        <template slot-scope="scope">
          <el-button
            type="warning"
            size="mini"
            @click="
              xiuGai = true;
              user_detail_id = scope.row.user_detail_id;
            "
            >修改</el-button
          >
        </template>
      </el-table-column>

      <!-- <el-table-column fixed="right" label="操作" width="100">
        <template slot-scope="scope">
          <el-button type="text" size="small">编辑</el-button>
          <el-button @click="handleClick(scope.row)" type="text" size="small">删除</el-button>
        </template>
      </el-table-column>-->
    </el-table>
    <div class="page">
      <el-pagination
        background
        hide-on-single-page
        @current-change="currentChange"
        layout="prev, pager, next"
        :total="total"
        :page-size="15"
        :current-page.sync="currentPage"
      ></el-pagination>
    </div>
    <!-- 搜索弹窗开始 -->
    <el-dialog
      title="搜索"
      :visible.sync="search_dialog"
      width="30%"
      :before-close="search_close"
    >
      <el-form label-width="120px" :model="formLabelAlign">
        <el-form-item label="姓名">
          <el-input v-model="formLabelAlign.name"></el-input>
        </el-form-item>
        <el-form-item label="帐号">
          <el-input v-model="formLabelAlign.username"></el-input>
        </el-form-item>
        <el-form-item label="手机号">
          <el-input
            v-model="formLabelAlign.phone"
            type="tel"
            @input="
              () => {
                if (formLabelAlign.phone.length > 11) {
                  formLabelAlign.phone = formLabelAlign.phone.slice(0, 11);
                }
              }
            "
          ></el-input>
        </el-form-item>
        <el-form-item label="公司名">
          <el-input v-model="formLabelAlign.company_name"></el-input>
        </el-form-item>
        <el-form-item label="是否为体验帐号">
          <!-- <el-input v-model="formLabelAlign.is_experience"></el-input> -->
          <el-select
            v-model="formLabelAlign.is_experience"
            placeholder="请选择是或否"
          >
            <el-option label="否" :value="0"></el-option>
            <el-option label="是" :value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="是否为测试账号">
          <!-- <el-input v-model="formLabelAlign.is_test"></el-input> -->
          <el-select
            v-model="formLabelAlign.is_test"
            placeholder="请选择是或否"
          >
            <el-option label="否" :value="0"></el-option>
            <el-option label="是" :value="1"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="search_qingKong" type="warning">清 空</el-button>
        <el-button @click="search_close_quxiao">取 消</el-button>
        <el-button type="primary" @click="search_dialog_yes">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="修改"
      :visible.sync="xiuGai"
      width="30%"
      :before-close="
        () => {
          xiuGai = false;
        }
      "
    >
      <el-form label-width="120px" :model="formXiugai">
        <el-form-item label="职员人数限制">
          <el-input v-model="formXiugai.people_permissions"></el-input>
        </el-form-item>
        <el-form-item label="经纪人人数限制">
          <el-input v-model="formXiugai.m_people_permissions"></el-input>
        </el-form-item>
        <el-form-item label="会员到期时间">
          <el-date-picker
            v-model="formXiugai.vip_end_time"
            type="date"
            placeholder="选择会员到期时间"
            format="yyyy-MM-dd"
            value-format="timestamp"
          ></el-date-picker>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <!-- <el-button @click="formXiugai={}" type="warning">清 空</el-button> -->
        <el-button
          @click="
            xiuGai = false;
            formXiugai = {};
          "
          >取 消</el-button
        >
        <el-button type="primary" @click="xiuGai_click">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 搜索弹窗结束 -->
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import { require } from "@/utils/http_request.js";
// import { delete } from 'vue/types/umd'

export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    //这里存放数据
    return {
      //列表数据
      tableData: [],
      //分页总页数
      total: 0,
      //当前的页数
      page: 1,
      //当前的页数
      currentPage: 1,
      //加载动画
      loading: true,
      //搜索弹窗开关
      search_dialog: false,
      //搜索弹窗form数据
      formLabelAlign: {},
      formXiugai: {},
      xiuGai: false,
      user_detail_id: "",
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    //搜索按钮事件
    search_click() {
      this.search_dialog = true; //弹窗开启
    },
    //搜索弹窗确定事件
    search_dialog_yes() {
      // let obj = this.formLabelAlign
      //调用api方法来获取筛选后的数据
      this.api(this.page, this.formLabelAlign);
      this.search_dialog = false; //弹窗关闭
    },
    //搜索弹窗关闭事件
    search_close_quxiao() {
      this.formLabelAlign = {}; //弹窗表单格式化清空
      this.search_dialog = false; //弹窗关闭
    },
    //搜索弹窗清空按钮
    search_qingKong() {
      this.formLabelAlign = {}; //弹窗表单格式化清空
      this.api(1);
      this.currentPage = 1;
      this.search_dialog = false; //弹窗关闭
    },
    //搜索弹窗关闭事件
    search_close() {
      // this.formLabelAlign = {} //弹窗表单格式化清空
      this.search_dialog = false; //弹窗关闭
    },
    //点击分页变化的钩子
    currentChange(page) {
      this.page = page;
      let is_page = false;
      for (let key in this.formLabelAlign) {
        if (this.formLabelAlign[key].length != 0) {
          is_page = true;
        }
      }
      // console.log(is_page)
      if (is_page) {
        this.api(this.page, this.formLabelAlign);
      } else {
        this.api(this.page);
      }
      // console.log(page)
    },
    //页面搜索和初始化数据
    api(page, search_data = {}) {
      require("post", "/lwbus_user/v1/lwbus_user_list/", {
        page,
        search_data,
      }).then((res) => {
        if (res.code == 0) {
          this.tableData = res.data;
          this.total = res.user_count; //表格数据绑定
          this.loading = false; //绑定总页数
        }
      });
    },
    xiuGai_click() {
      var reg = /^[0-9]+.?[0-9]*$/;
      if (
        this.formXiugai.people_permissions &&
        !reg.test(this.formXiugai.people_permissions)
      ) {
        this.$message.warning("请正确输入职员人数");
        return false;
      }
      if (
        this.formXiugai.m_people_permissions &&
        !reg.test(this.formXiugai.m_people_permissions)
      ) {
        this.$message.warning("请正确输入经纪人人数");
        return false;
      }
      if (
        this.formXiugai.vip_end_time &&
        !reg.test(this.formXiugai.vip_end_time)
      ) {
        this.$message.warning("请正确选择会员结束时间");
        return false;
      }

      for (let key in this.formXiugai) {
        if (!this.formXiugai[key]) {
          delete this.formXiugai[key];
        } else {
          this.formXiugai[key] = Number(this.formXiugai[key]);
          if (key == "vip_end_time") {
            this.formXiugai[key] = Number(this.formXiugai[key]) / 1000;
          }
        }
      }
      if (JSON.stringify(this.formXiugai) == "{}") {
        this.$message.warning("请输入或选择修改内容");
        return false;
      }
      require("post", "/lwbus_user/v1/lwbus_update_user/", {
        user_detail_id: this.user_detail_id,
        update_data: this.formXiugai,
      }).then((res) => {
        if (res.code == 0) {
          this.xiuGai = false;
          this.formXiugai = {};
          this.api(this.page);
        }
      });
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.api(this.page); //初始化数据
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style scoped>
/* //@import url(); 引入公共css类 */
.RegistrationList {
  padding: 0px 20px;
  width: calc(100% - 221px);
  position: relative;
  left: 181px;
  top: 68px;
  min-height: 80vh;
}
.cao_zuo {
  padding: 12px 0;
  overflow: hidden;
}
.page {
  text-align: center;
  padding: 12px 0;
}
</style>



// WEBPACK FOOTER //
// src/lwbus/RegistrationList.vue